export default __webpack_public_path__ + "static/media/100_sp.13bf4eae.png";